import React, { useState } from 'react';
import '../App.css';

const ContactPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    workedWithArchitect: '',
    projectType: [],
    location: '',
    timeline: '',
    budget: '',
    builderEngagement: '',
    builderName: '',
    designBrief: '',
    referral: '',
    otherDetails: ''
  });

  const totalSteps = 8;

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        projectType: checked 
          ? [...prev.projectType, value]
          : prev.projectType.filter(item => item !== value)
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
    // You would typically send this data to a server here
    alert('Thanks for reaching out. We\'ve received your enquiry and will be in touch soon.');
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="contact_form_group">
            <div className="contact_form_group_top">
              <div className="contact_form_group_title u-text-small">
                <div className="g_eyebrow u-text-small">아래 정보를 입력하세요.</div>
                <div className="contact_form_group_index">(01/08)</div>
              </div>
              <div className="contact_form_group_field">
                <label htmlFor="Name" className="contact_field_label u-text-small">이름
                  <span className="u-required">*</span>
                </label>
                <input 
                  className="contact_field_input w-input" 
                  maxLength="256"
                  name="name" 
                  data-name="Name" 
                  min="1" 
                  placeholder="Johnny Hyde" 
                  type="text" 
                  id="Name" 
                  required 
                  value={formData.name}
                  onChange={handleInputChange}
                />
                <div className="contact_field_error u-text-small">이름을 입력하세요.</div>
              </div>
              <div className="contact_form_group_field">
                <label htmlFor="Email" className="contact_field_label u-text-small">이메일 
                  <span className="u-required">*</span>
                </label>
                <input 
                  className="contact_field_input w-input"
                  maxLength="256" 
                  name="email" 
                  data-name="Email" 
                  placeholder="info@faire323.pro" 
                  type="email"
                  id="Email" 
                  required 
                  value={formData.email}
                  onChange={handleInputChange}
                />
                <div className="contact_field_error u-text-small">이메일을 입력하세요.</div>
              </div>
              <div className="contact_form_group_field">
                <label htmlFor="Phone-Number"
                  className="contact_field_label u-text-small">전화번호
                </label>
                <input
                  className="contact_field_input w-input" 
                  maxLength="256" 
                  name="phone" 
                  data-name="Phone Number"
                  placeholder="07 1234 5678" 
                  type="tel" 
                  id="Phone-Number" 
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="contact_form_group_navigation">
              <button type="button" className="contact_navigation_next" onClick={nextStep}>
                <span className="contact_next_contain">
                  <div className="btn_default_text">다음</div>
                </span>
              </button>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="contact_form_group">
            <div className="contact_form_group_top">
              <div className="contact_form_group_title u-text-small">
                <div className="g_eyebrow u-text-small">상세정보 입력</div>
                <div className="contact_form_group_index">(02/08)</div>
              </div>
              <div className="form-field-group">
                <label htmlFor="Email-3" className="contact_field_label u-text-small">Have you
                  worked with an architect before? <span className="u-required">*</span>
                </label>
                <div role="list" className="radiocheck-group is-grid u-text-small">
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="workedWithArchitect" 
                      id="Yes"
                      data-name="Worked with Arch Before?" 
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="Yes" 
                      checked={formData.workedWithArchitect === 'Yes'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="Yes">Yes</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="workedWithArchitect" 
                      id="No"
                      data-name="Worked with Arch Before?" 
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="No" 
                      checked={formData.workedWithArchitect === 'No'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label u-text-mono w-form-label" htmlFor="No">no</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="contact_form_group_navigation">
              <button onClick={prevStep} className="contact_navigation_prev u-text-small">
                <div className="btn_default_text is-prev">뒤로</div>
              </button>
              <button type="button" className="contact_navigation_next" onClick={nextStep}>
                <span className="contact_next_contain">
                  <div className="btn_default_text">다음</div>
                </span>
              </button>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="contact_form_group">
            <div className="contact_form_group_top">
              <div className="contact_form_group_title u-text-small">
                <div className="g_eyebrow u-text-small">Project particulars</div>
                <div className="contact_form_group_index">(03/08)</div>
              </div>
              <div className="form-field-group">
                <label htmlFor="Email-3" className="contact_field_label u-text-small">What type of
                  project are you looking for? <span className="u-required">*</span> 
                  <span className="u-label-deco">(select multiple if needed) </span>
                </label>
                <div role="list" className="checkbox-group is-grid u-text-small">
                  <label role="listitem" className="w-checkbox checkbox-field">
                    <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-input"></div>
                    <input
                      type="checkbox"
                      name="projectType"
                      id="New-Home"
                      data-name="New Home"
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="New home"
                      checked={formData.projectType.includes('New home')}
                      onChange={handleInputChange}
                    />
                    <span className="checkbox-label w-form-label" htmlFor="New-Home">New home</span>
                  </label>
                  <label role="listitem" className="w-checkbox checkbox-field">
                    <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-input"></div>
                    <input
                      type="checkbox"
                      name="projectType"
                      id="Renovations-Extensions"
                      data-name="Renovations Extensions"
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="Renovation + extensions"
                      checked={formData.projectType.includes('Renovation + extensions')}
                      onChange={handleInputChange}
                    />
                    <span className="checkbox-label w-form-label" htmlFor="Renovations-Extensions">Renovation + extensions</span>
                  </label>
                  <label role="listitem" className="w-checkbox checkbox-field">
                    <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-input"></div>
                    <input
                      type="checkbox"
                      name="projectType"
                      id="Commerical"
                      data-name="Commerical"
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="Commercial project"
                      checked={formData.projectType.includes('Commercial project')}
                      onChange={handleInputChange}
                    />
                    <span className="checkbox-label w-form-label" htmlFor="Commerical">Commercial project</span>
                  </label>
                  <label role="listitem" className="w-checkbox checkbox-field">
                    <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-input"></div>
                    <input
                      type="checkbox"
                      name="projectType"
                      id="Interior-Design"
                      data-name="Interior Design"
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="Interior Design Only"
                      checked={formData.projectType.includes('Interior Design Only')}
                      onChange={handleInputChange}
                    />
                    <span className="checkbox-label w-form-label" htmlFor="Interior-Design">Interior Design Only</span>
                  </label>
                  <label role="listitem" className="w-checkbox checkbox-field">
                    <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-input"></div>
                    <input
                      type="checkbox"
                      name="projectType"
                      id="Other"
                      data-name="Other"
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="Other / Unsure"
                      checked={formData.projectType.includes('Other / Unsure')}
                      onChange={handleInputChange}
                    />
                    <span className="checkbox-label w-form-label" htmlFor="Other">Other / Unsure</span>
                  </label>
                </div>
                <div className="contact_field_error u-text-small">Please select at least one option.</div>
              </div>
            </div>
            <div className="contact_form_group_navigation">
              <button onClick={prevStep} className="contact_navigation_prev u-text-small">
                <div className="btn_default_text is-prev">Back</div>
              </button>
              <button type="button" className="contact_navigation_next" onClick={nextStep}>
                <span className="contact_next_contain">
                  <div className="btn_default_text">Next</div>
                </span>
              </button>
            </div>
          </div>
        );
      case 4:
        return (
          <div className="contact_form_group">
            <div className="contact_form_group_top">
              <div className="contact_form_group_title u-text-small">
                <div className="g_eyebrow u-text-small">Project particulars</div>
                <div className="contact_form_group_index">(04/08)</div>
              </div>
              <div className="contact_form_group_field">
                <label htmlFor="Location"
                  className="contact_field_label u-text-small">Where are you planning to build your project? 
                  <span className="u-required">*</span>
                </label>
                <input 
                  className="contact_field_input w-input" 
                  maxLength="256"
                  name="location" 
                  data-name="Location" 
                  min="3" 
                  placeholder="Ashgrove, QLD" 
                  type="text" 
                  id="Location"
                  required 
                  value={formData.location}
                  onChange={handleInputChange}
                />
                <div className="contact_field_error u-text-small">Please enter a build location for your project.</div>
              </div>
              <div className="contact_form_group_field">
                <label htmlFor="Timeline"
                  className="contact_field_label u-text-small">Project timeline for designs and/or build (if known)
                </label>
                <input 
                  className="contact_field_input w-input" 
                  maxLength="256" 
                  name="timeline"
                  data-name="Timeline" 
                  placeholder="6-8 months" 
                  type="text" 
                  id="Timeline" 
                  value={formData.timeline}
                  onChange={handleInputChange}
                />
                <div className="contact_field_support u-text-small">
                  Note: our studio has an 8-12 week minimum wait time to commence new projects. 
                  Project timelines vary depending on a range of factors but we ask that you allow 
                  a minimum of 6 to 12 months from commencement to delivery of construction plans ready for build.
                </div>
              </div>
            </div>
            <div className="contact_form_group_navigation">
              <button onClick={prevStep} className="contact_navigation_prev u-text-small">
                <div className="btn_default_text is-prev">Back</div>
              </button>
              <button type="button" className="contact_navigation_next" onClick={nextStep}>
                <span className="contact_next_contain">
                  <div className="btn_default_text">Next</div>
                </span>
              </button>
            </div>
          </div>
        );
      case 5:
        return (
          <div className="contact_form_group">
            <div className="contact_form_group_top">
              <div className="contact_form_group_title u-text-small">
                <div className="g_eyebrow u-text-small">Project particulars</div>
                <div className="contact_form_group_index">(05/08)</div>
              </div>
              <div className="form-field-group">
                <label htmlFor="Email-3" className="contact_field_label u-text-small">Project budget range (if known)</label>
                <div role="list" className="radiocheck-group is-grid u-text-small">
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="budget" 
                      id="500k" 
                      data-name="Project Budget"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="< $500k" 
                      checked={formData.budget === '< $500k'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="500k">&lt; $500k</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="budget" 
                      id="500k---1-Mil" 
                      data-name="Project Budget"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="$500k - $1 Mil" 
                      checked={formData.budget === '$500k - $1 Mil'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="500k---1-Mil">$500k - $1 Mil</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="budget" 
                      id="1-Mil---1.5-Mil" 
                      data-name="Project Budget"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="$1 Mil - $1.5 Mil" 
                      checked={formData.budget === '$1 Mil - $1.5 Mil'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="1-Mil---1.5-Mil">$1 Mil - $1.5 Mil</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="budget" 
                      id="1.5-Mil---2.5-Mil" 
                      data-name="Project Budget"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="$1.5 Mil - $2.5 Mil" 
                      checked={formData.budget === '$1.5 Mil - $2.5 Mil'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="1.5-Mil---2.5-Mil">$1.5 Mil - $2.5 Mil</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="budget" 
                      id="2.5-Mil" 
                      data-name="Project Budget"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="$2.5 Mil+" 
                      checked={formData.budget === '$2.5 Mil+'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="2.5-Mil">$2.5 Mil+</span>
                  </label>
                </div>
                <div className="contact_field_support u-text-small">
                  Note: our design fees start from a minimum of $4,500-$6,000 p/m 2 . 
                  Project costs can vary significantly depending on your needs. We will create a
                  custom proposal for your project, including detailed fees and inclusions, 
                  once after we meet to provide clarity on any costs moving forward.
                </div>
              </div>
            </div>
            <div className="contact_form_group_navigation">
              <button onClick={prevStep} className="contact_navigation_prev u-text-small">
                <div className="btn_default_text is-prev">Back</div>
              </button>
              <button type="button" className="contact_navigation_next" onClick={nextStep}>
                <span className="contact_next_contain">
                  <div className="btn_default_text">Next</div>
                </span>
              </button>
            </div>
          </div>
        );
      case 6:
        return (
          <div className="contact_form_group">
            <div className="contact_form_group_top">
              <div className="contact_form_group_title u-text-small">
                <div className="g_eyebrow u-text-small">Project particulars</div>
                <div className="contact_form_group_index">(06/08)</div>
              </div>
              <div className="form-field-group">
                <label htmlFor="Email-3" className="contact_field_label u-text-small">Have you engaged a builder?</label>
                <div className="radiocheck-group is-grid u-text-small">
                  <label className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="builderEngagement" 
                      id="Yes-2" 
                      data-name="Builder Engagement"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="Yes" 
                      checked={formData.builderEngagement === 'Yes'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="Yes-2">Yes</span>
                  </label>
                  <label className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="builderEngagement" 
                      id="NOT-YET-BUT-WE-HAVE-SOMEONE-IN-MIND"
                      data-name="Builder Engagement" 
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="NOT YET, BUT WE HAVE SOMEONE IN MIND" 
                      checked={formData.builderEngagement === 'NOT YET, BUT WE HAVE SOMEONE IN MIND'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="NOT-YET-BUT-WE-HAVE-SOMEONE-IN-MIND">
                      NOT YET, BUT WE HAVE SOMEONE IN MIND
                    </span>
                  </label>
                  <label className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="builderEngagement"
                      id="NO-WE-WOULD-LIKE-HELP-WITH-SELECTING-A-BUILDER" 
                      data-name="Builder Engagement"
                      style={{opacity:0,position:'absolute',zIndex:-1}}
                      value="NO, WE WOULD LIKE HELP WITH SELECTING A BUILDER" 
                      checked={formData.builderEngagement === 'NO, WE WOULD LIKE HELP WITH SELECTING A BUILDER'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="NO-WE-WOULD-LIKE-HELP-WITH-SELECTING-A-BUILDER">
                      NO, WE WOULD LIKE HELP WITH SELECTING A BUILDER
                    </span>
                  </label>
                </div>
              </div>
              <div className="contact_form_group_field">
                <label htmlFor="Builder-Name"
                  className="contact_field_label u-text-small">Builder details (if you answered yes above, please provide
                  builder name and other details below)
                </label>
                <input 
                  className="contact_field_input w-input"
                  maxLength="256" 
                  name="builderName" 
                  data-name="Builder Name" 
                  placeholder="Builder / Engineer Name"
                  type="text" 
                  id="Builder-Name" 
                  value={formData.builderName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="contact_form_group_navigation">
              <button onClick={prevStep} className="contact_navigation_prev u-text-small">
                <div className="btn_default_text is-prev">Back</div>
              </button>
              <button type="button" className="contact_navigation_next" onClick={nextStep}>
                <span className="contact_next_contain">
                  <div className="btn_default_text">Next</div>
                </span>
              </button>
            </div>
          </div>
        );
      case 7:
        return (
          <div className="contact_form_group">
            <div className="contact_form_group_top">
              <div className="contact_form_group_title u-text-small">
                <div className="g_eyebrow u-text-small">Project particulars</div>
                <div className="contact_form_group_index">(07/08)</div>
              </div>
              <div className="contact_form_group_field">
                <label htmlFor="Design-Brief"
                  className="contact_field_label u-text-small">Design brief (provide any additional information, ideas and
                  details you may have for your project here)
                </label>
                <textarea
                  placeholder="Hi FAIRE 323 team, I would like to..." 
                  maxLength="5000" 
                  id="Design-Brief"
                  name="designBrief" 
                  data-name="Design Brief"
                  className="contact_field_input is-textarea w-input"
                  value={formData.designBrief}
                  onChange={handleInputChange}
                ></textarea>
              </div>
            </div>
            <div className="contact_form_group_navigation">
              <button onClick={prevStep} className="contact_navigation_prev u-text-small">
                <div className="btn_default_text is-prev">Back</div>
              </button>
              <button type="button" className="contact_navigation_next" onClick={nextStep}>
                <span className="contact_next_contain">
                  <div className="btn_default_text">Next</div>
                </span>
              </button>
            </div>
          </div>
        );
      case 8:
        return (
          <div className="contact_form_group">
            <div className="contact_form_group_top">
              <div className="contact_form_group_title u-text-small">
                <div className="g_eyebrow u-text-small">ADDItional Information</div>
                <div className="contact_form_group_index">(08/08)</div>
              </div>
              <div className="form-field-group">
                <label htmlFor="Email-3" className="contact_field_label u-text-small">How did you hear about us?</label>
                <div role="list" className="radiocheck-group is-grid u-text-small">
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="referral" 
                      id="Friend" 
                      data-name="Referral"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="Friend" 
                      checked={formData.referral === 'Friend'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="Friend">Friend</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="referral" 
                      id="Family" 
                      data-name="Referral"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="Family" 
                      checked={formData.referral === 'Family'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="Family">Family</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="referral" 
                      id="Google" 
                      data-name="Referral"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="Google" 
                      checked={formData.referral === 'Google'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="Google">Google</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="referral" 
                      id="Instagram" 
                      data-name="Referral"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="Instagram" 
                      checked={formData.referral === 'Instagram'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="Instagram">Instagram</span>
                  </label>
                  <label role="listitem" className="radio-field w-radio">
                    <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input"></div>
                    <input 
                      type="radio" 
                      name="referral" 
                      id="Other-2" 
                      data-name="Referral"
                      style={{opacity:0,position:'absolute',zIndex:-1}} 
                      value="Other" 
                      checked={formData.referral === 'Other'}
                      onChange={handleInputChange}
                    />
                    <span className="radio-label w-form-label" htmlFor="Other-2">Other</span>
                  </label>
                </div>
              </div>
              <div className="contact_form_group_field">
                <label htmlFor="Other-Details-2"
                  className="contact_field_label u-text-small">If you selected &quot;Other&quot; above, please provide
                  details below
                </label>
                <input 
                  className="contact_field_input w-input" 
                  maxLength="256" 
                  name="otherDetails"
                  data-name="Other Details" 
                  placeholder="" 
                  type="text" 
                  id="Other-Details-2" 
                  value={formData.otherDetails}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="contact_form_group_navigation">
              <button onClick={prevStep} className="contact_navigation_prev u-text-small">
                <div className="btn_default_text is-prev">Back</div>
              </button>
              <div className="contact_navigation_next">
                <input 
                  type="submit"
                  className="form-submit w-button" 
                  value="Submit" 
                />
                <span className="contact_next_contain is-submit">
                  <div className="btn_default_text">Submit Form</div>
                </span>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="contact_wrap">
      <div className="code-embed w-embed">
        <style>
          {`
            .radiocheck-field input:focus-visible:checked~.radiocheck-custom,
            .radiocheck-field input:checked~.radiocheck-custom {
              background-color: var(--swatch--white);
              color: var(--swatch--black);
            }

            .radiocheck-group .radio-field input:checked~.radio-field,
            .checkbox-group .checkbox-field input:checked~.checkbox-field {
              background-color: var(--swatch--black);
            }

            .radiocheck-group .radio-field input:checked+.radio-label,
            .checkbox-group .checkbox-field input:checked+.checkbox-label {
              color: var(--swatch--black);
            }

            .radio-button,
            .checkbox-input,
            .checkbox-label,
            .radio-label {
              transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
            }

            /* Field: Select */
            [data-validate] select:has(option[value=""]:checked) {
              color: rgba(19, 19, 19, 0.3);
            }
          `}
        </style>
      </div>
      <div className="contact_modal_wrap">
        <div className="contact_header_wrap">
          <div className="contact_header_content">
            <div className="contact_header_eyebrow">
              <div className="g_eyebrow u-text-small">건축/인테리어 상담</div>
            </div>
            <p className="contact_header_paragraph u-text-main is-header">
              저희와 함께 만들고 싶은 공간에 대해 몇 가지 세부 사항을 알려주세요. 
              아래 양식을 작성해 주시면, 저희가 고객님의 프로젝트에 가장 적합한 파트너인지 검토해 볼 수 있습니다. <br />
              032-288-4896
            </p>
          </div>
          <div className="contact_header_aside">
            <button className="menu_navbar_close" onClick={() => window.history.back()}>
              <div className="menu_navbar_text u-text-small">Close</div>
            </button>
          </div>
        </div>
        <div className="contact_form_wrap">
          <div className="contact_form_contain w-form">
            <form 
              id="wf-form-Enquiry-Form" 
              name="wf-form-Enquiry-Form" 
              data-name="Enquiry Form" 
              method="get"
              className="contact_form_main" 
              onSubmit={handleSubmit}
            >
              <div className="contact_progress_wrap">
                <div className="contact_progress_bar"></div>
              </div>
              {renderStep()}
            </form>
            <div className="success_wrap w-form-done">
              <p className="success_paragraph u-text-h3">Thanks for reaching out. We've received your enquiry and will be in touch soon.</p>
            </div>
            <div className="w-form-fail">
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;